import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 角色 - 多筆資料 Schema
 */
export const roleListDataSchema = z.object({
  /** 是否可刪除 */
  canDelete: z.nativeEnum(TrueFalse),
  /** 預設角色 */
  isDefault: z.nativeEnum(TrueFalse),
  /** 角色說明 */
  memo: z.string(),
  /** 異動日期 */
  modifyDate: z.string(),
  /** 異動者 */
  modifyUser: z.string(),
  /** 角色類型代碼 */
  roleClass: z.string(),
  /** 角色類型名稱 */
  roleClassNameZh: z.string(),
  /** 角色代碼 */
  roleCode: z.string(),
  /** 後台可使用的模組 */
  roleMenu: z.array(z.string()),
  /** 角色名稱 */
  roleName: z.string(),
  /** 是否可進入後台 */
  toBackend: z.nativeEnum(TrueFalse)
})

/**
 * 角色 - 多筆資料
 */
export interface RoleListData extends z.infer<typeof roleListDataSchema> {}
